import React, { createContext, useContext, useEffect, useState } from 'react'
import io from 'socket.io-client';
import Loader from '../comonComponent/loader/Loader';
import { useDispatch } from 'react-redux';
import { SET_MAIN_LOADER } from '../redux/loaderSlice';
import SuccessMessagePopup from '../comonComponent/success-message-popup/SuccessMessagePopup';
import ErrorMessagePopup from '../comonComponent/error-message-popup/ErrorMessagePopup';
import { toast } from 'react-toastify';

const SocketContext = createContext();

function SocketProvider({ children }) {
  const dispatch = useDispatch()
  const [socket, setSocket] = useState(null);
  const [connectionError, setConnectionError] = useState(null);

  const state = {
    socket,
    setSocket,
    connectionError,
    reconnect: initializeSocketConnection
  };

  // Initialize socket connection
  async function initializeSocketConnection() {
    dispatch(SET_MAIN_LOADER(true));
    setConnectionError(null);

    try {
      //       const response = await fetch("http://43.204.22.233:3000/chooseServer?det=android");
      
      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }
      
      // const data = await response.json();
      // const urlPort = `http://${data.SOCKET_URL.host}:${data.SOCKET_URL.port}`;

      const urlPort = `https://server.7starlotto.com/`;
      
      // Disconnect existing socket if any
      if (socket) {
        socket.disconnect();
      }

      const socketInstance = io(urlPort, {
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        pingInterval: 24 * 60 * 60 * 1000,
        pingTimeout: 3 * 24 * 60 * 60 * 1000,
      });

      socketInstance.on('connect', () => {
        
        handleSocketConnect(socketInstance);
      });

      socketInstance.on('disconnect', (reason) => {
        
        if (reason === 'io server disconnect') {
          // The server forcibly disconnected the socket
          socketInstance.connect();
        }
      });

      socketInstance.on('connect_error', (error) => {
        console.error('Socket connection error:', error);
        toast.error('Socket connection error');
        setConnectionError(error.message);
        dispatch(SET_MAIN_LOADER(false));
      });

      setSocket(socketInstance);
      dispatch(SET_MAIN_LOADER(false));

    } catch (err) {
      console.error('Socket initialization error:', err);
      setConnectionError(err.message);
      dispatch(SET_MAIN_LOADER(false));
    }
  }

  // Handle socket connection
  function handleSocketConnect(socketInstance) {
    if (window.location.pathname.includes('/login') && localStorage.getItem('creditionls')) {
      dispatch(SET_MAIN_LOADER(true));
      const creditionls = localStorage.getItem('creditionls');
      const data = {
        "en": "AppLunchDetails",
        "data": JSON.parse(creditionls)
      };
      socketInstance.emit("req", data);
      dispatch(SET_MAIN_LOADER(false));
    }
  }

  // Initialize connection on mount
  useEffect(() => {
    initializeSocketConnection();

    // Cleanup on unmount
    return () => {
      if (socket) {
        socket.off('connect');
        socket.off('disconnect');
        socket.off('connect_error');
        socket.disconnect();
      }
    };
  }, []);

  // Network status listeners
  useEffect(() => {
    const handleOnline = () => {
      
      initializeSocketConnection();
    };

    const handleOffline = () => {
      
      toast.warn('Network connection lost');
      if (socket) {
        socket.disconnect();
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [socket]);

  return (
    <SocketContext.Provider value={state}>
      <Loader />
      <SuccessMessagePopup />
      <ErrorMessagePopup />
      {socket ? children : null}
    </SocketContext.Provider>
  );
}

const SocketState = () => useContext(SocketContext);

export { SocketState };
export default SocketProvider;